interface Props {
  color?: string;
  className?: string;
}

export default function MenuUserSvg(props: Props) {
  return (
    <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.5 14C15.2614 14 17.5 11.7614 17.5 9C17.5 6.23858 15.2614 4 12.5 4C9.73858 4 7.5 6.23858 7.5 9C7.5 11.7614 9.73858 14 12.5 14ZM12.5 14C8.08172 14 4.5 16.6863 4.5 20M12.5 14C16.9183 14 20.5 16.6863 20.5 20'
        stroke={props.color || '#737389'}
        strokeWidth='2'
        stroke-linecap='round'
      />
    </svg>
  );
}
